import { render, staticRenderFns } from "./tableComponent.vue?vue&type=template&id=6cd43d22"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports